export const SORT_OPTIONS = [
  { value: 'recommended', label: 'おすすめ順' },
  { value: 'price-low', label: '価格の安い順' },
  { value: 'price-high', label: '価格の高い順' },
  { value: 'newest', label: '新着順' },
] as const

export const genderOptions = [
  { id: '1', label: 'ウィメンズ' },
  { id: '0', label: 'メンズ' },
  { id: '3', label: 'ユニセックス' },
  { id: '2', label: 'キッズ' },
]

export const DEFAULT_COLOR = '#9A8E8E'

export const SIDEBAR_WIDTH = 300

export const ANIMATION_DURATION = 0.3

export const PAGINATION = {
  TOTAL_PAGES: 10,
  SIBLINGS: 1,
} as const

export const BREAKPOINTS = {
  mobile: 768,
} as const
